import * as React from 'react'
import { SVGProps } from 'react'
const SvgAngleLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg width={1706.667} height={1706.667} viewBox="0 0 1280 1280" {...props}>
    <path d="M597.5 319.8c-180.9 175.8-329 319.9-329 320.2 0 1 657.7 639.5 658.9 639.8.7.1 14-12.9 29.6-29 15.7-16.1 34.5-35.4 41.8-42.9l13.3-13.7-285-276.8C570.3 765.2 442 640.3 442 640c0-.3 128.3-125.1 285-277.4l285.1-276.9-12.3-12.6c-6.8-6.9-25.6-26.2-41.7-42.9C941.9 13.6 928.2 0 927.6.1 927 .1 778.5 144 597.5 319.8z" />
  </svg>
)
export default SvgAngleLeft
